import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "md-ripple" }
const _hoisted_3 = ["value", "id", "name"]
const _hoisted_4 = ["for"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.options, (option, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(`md-radio md-theme-default ${option.id == _ctx.defaultOption ? `md-checked` : ``} ${
                _ctx.type && _ctx.type == `horizon` ? `fl` : ``
            }`),
        key: index
      }, [
        _createElementVNode("div", {
          class: "md-radio-container pointer",
          onClick: ($event: any) => (_ctx.selectRadio(option.id))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("input", {
              type: "radio",
              value: option.id,
              id: `${_ctx.optionName}_${option.id}`,
              name: _ctx.optionName,
              class: _normalizeClass(`fl ${_ctx.optionName ? _ctx.optionName : `a`}_radio pointer`),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectId && _ctx.selectId(...args)))
            }, null, 10, _hoisted_3)
          ])
        ], 8, _hoisted_1),
        _createElementVNode("label", {
          for: `${_ctx.optionName}_${option.id}`,
          class: "md-radio-label pointer"
        }, _toDisplayString(option.name), 9, _hoisted_4),
        (_ctx.type != `horizon`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}